import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import * as React from "react";
import { getSafeId, noop } from '../../Util';
export var FocusGroupContext = React.createContext({
    onFocus: noop
});
var FocusGroup = /** @class */ (function (_super) {
    tslib_1.__extends(FocusGroup, _super);
    function FocusGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onFocus = function (id) {
            _this.setState({ focusedElementId: id });
        };
        _this.state = { focusedElementId: props.defaultElementId };
        return _this;
    }
    FocusGroup.prototype.render = function () {
        return (React.createElement(FocusGroupContext.Provider, { value: {
                focusedElementId: this.state.focusedElementId,
                onFocus: this.onFocus
            } }, this.props.children));
    };
    FocusGroup.prototype.focus = function (elementId) {
        var id = getSafeId(elementId || this.state.focusedElementId);
        if (id) {
            var element = document.getElementById(id);
            if (element) {
                element.focus();
            }
        }
    };
    return FocusGroup;
}(React.Component));
export { FocusGroup };
